import { Component, inject, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { ActivatedRoute, Router, RouterOutlet } from "@angular/router";
import { Subscription } from "rxjs";
import { v4 as generateUUID } from "uuid";
import { ApplicationService } from "../../services/application.service";
import { AuthService } from "../../services/auth.service";
import { StorageService } from "../../services/storage.service";
import { MatProgressSpinner } from "@angular/material/progress-spinner";

export interface DashboardMenu {
  menu: {
    description: string;
    items: {
      label: string;
      route: string;
      index: number;
    }[];
  };
}

@Component({
  selector: "app-screen-content",
  templateUrl: "./content.html",
  styleUrls: ["./content.less"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatProgressSpinner, RouterOutlet],
})
export class ContentComponent implements OnDestroy, OnInit {
  readonly applicationService = inject(ApplicationService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  protected static readonly TITLE = "Dashboard ";

  public id: string = generateUUID();
  public loading = true;
  private readonly storageService: StorageService;

  private auth = inject(AuthService);

  @ViewChild("children")
  public children: unknown;

  public sessionSubscription?: Subscription;

  public constructor() {
    this.storageService = inject(StorageService);
  }

  public ngOnInit() {
    if (this.router.url == "/content") {
      this.applicationService.updateTitle("");
      this.sessionSubscription = this.auth.session.subscribe(() => {
        this.redirect();
      });
    }
  }

  public ngOnDestroy() {
    this.applicationService.unsubscribe(this.id);
  }

  /**
   * Redirect to correct url based on your permissions
   */
  public async redirect() {
    if (this.auth.isCoach()) {
      this.router.navigate(["coach"], { relativeTo: this.route });
    }
    if (this.auth.isCoordinator()) {
      this.router.navigate(["coordinator"], { relativeTo: this.route });
    }
    if (this.auth.isResident()) {
      this.router.navigate(["resident"], { relativeTo: this.route });
    }
  }
}
